export default __webpack_public_path__ + "components/weather-icon/static/nightheavysnow-ba41ce3354368810d761c50d2ac6544f.png";